module.exports = {"select_gender":"Select your gender","male":"Male","female":"Female"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/gender.json
// module id = 643
// module chunks = 247 1450